import React from "react";


const Tecnico = () => {

return(<div>Tecnico</div>)

}

export default Tecnico;